<template>

  <el-form label-position="left" label-width="auto" size="small">
    <el-collapse :accordion="true">
      <chart-title :element="element"></chart-title>
      <chart-sub-title :element="element"></chart-sub-title>
      <chart-legend :element="element"></chart-legend>
      <chart-grid :element="element"></chart-grid>
      <chart-draw :element="element">
        <template #default>


          <el-form-item label="平滑">
            <el-switch v-model="ele.option.smooth" active-color="#55aaff" inactive-color="#cfcfcf"
                       @change="handleChangeSmooth"></el-switch>
          </el-form-item>

          <el-form-item label="面积图">
            <el-switch v-model="ele.option.area" active-color="#55aaff" inactive-color="#cfcfcf"
                       @change="handleChangeArea"></el-switch>
          </el-form-item>

          <el-form-item label="堆叠">
            <el-switch v-model="ele.option.stack" active-color="#55aaff" inactive-color="#cfcfcf"
                       @change="handleChangeStack"></el-switch>
          </el-form-item>


        </template>
      </chart-draw>
      <chart-x-axis :element="element"></chart-x-axis>
      <chart-y-axis :element="element"></chart-y-axis>
    </el-collapse>
  </el-form>

</template>

<script>
import ChartTitle from "@/components/design-report/chart/chartStyle/chartTitle.vue";
import ChartLegend from "@/components/design-report/chart/chartStyle/chartLegend.vue";
import ChartSubTitle from "@/components/design-report/chart/chartStyle/chartSubTitle.vue";
import ChartGrid from "@/components/design-report/chart/chartStyle/chartGrid.vue";
import ChartXAxis from "@/components/design-report/chart/chartStyle/chartXAxis.vue";
import ChartYAxis from "@/components/design-report/chart/chartStyle/chartYAxis.vue";
import ChartDraw from "@/components/design-report/chart/chartStyle/chartDraw.vue";

export default {
  components: {ChartDraw, ChartYAxis, ChartXAxis, ChartGrid, ChartSubTitle, ChartLegend, ChartTitle},
  props: {
    element: {
      type: Object,
      default: () => {
      }
    },
    report: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      ele: null
    }
  },
  created() {
    this.ele = this.element;
  },
  methods: {
    handleChangeSmooth(flag) {
      this.element.option.series.forEach(item => {
        item.smooth = flag
      })
    },
    handleChangeArea(flag) {
      this.element.option.series.forEach(item => {
        if (flag) {
          item.areaStyle = {opacity: 0.5}
        } else {
          delete item.areaStyle;
        }
      })
    },
    handleChangeStack(value) {
      this.element.option.series.forEach(item => {
        item.stack = value
      })
    }
  }


}

</script>

<style scoped lang="scss">

</style>